// extracted by mini-css-extract-plugin
export var WhatsNewNoResults = "whatsNew-module--WhatsNewNoResults--04ef4";
export var subTitle = "whatsNew-module--subTitle--cead7";
export var title = "whatsNew-module--title--0daa3";